
import React, { useEffect, useState, Fragment, Suspense, useRef } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { Trans, useTranslation } from "react-i18next";

import '@google/model-viewer/dist/model-viewer';

import { Button, IconButton } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";

import logo from '../../../../img/logo.svg';
import CubeIcon from "../../../icons/CubeIcon";

import apiClient from "../../../../services/api";
import store from "../../../../store";
import { toggleMessageOpen } from "../../../../store/actions/Message";

function ProjectPublicAR() {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const modelRef = useRef();
    //const projectData = useSelector((state) => state.project.selectedProject);

    const [projectId, setProjectId] = useState(null);
    const [url, setUrl] = useState(null);
    const [usdzUrl, setUsdzUrl] = useState(null);
    const [name, setName] = useState();
    const [glbUrl, setGlbUrl] = useState(null);
    const [token, setToken] = useState('');

    const [decoderLoaded, setDecoderLoaded] = useState(false);
    const [decoder, setDecoder] = useState(null);
    const [final, setFinal] = useState(null);

    useEffect(() => {
        const urlParams = window.location.href.split('/');
        setToken(urlParams.at(-2));
    }, []);

    useEffect(() => {
        if (!token) {
            return;
        }

        apiClient.post('/api/projects/load-public', { token: token }).then(response => {
            if (!response.data.success) {
                return;
            }

            const projectData = response.data;

            if (projectData.project) {
                setProjectId(projectData.project.id);
            }

            if (projectData.model && projectData.model.usdz) {
                setGlbUrl(projectData.model.usdz);
            } else if (usdzUrl) {
                setGlbUrl(usdzUrl);
            }

            if (projectData.project) {
                setName(projectData.project.name);
            }

            if (projectData.model && projectData.model.usdz) {
                setUsdzUrl(projectData.model.usdz);
            }

        }).catch(error => {
            store.dispatch(toggleMessageOpen(t('An error occurred while selecting project'), "error"));
        });


    }, [token]);// eslint-disable-line react-hooks/exhaustive-deps

    const iframeRef = useRef();

    function getMobileOperatingSystem() {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    
        // Windows Phone must come first because its UA also contains "Android"
        if (/windows phone/i.test(userAgent)) {
            return "Windows Phone";
        }
    
        if (/android/i.test(userAgent)) {
            return "Android";
        }
    
        // iOS detection from: http://stackoverflow.com/a/9039885/177710
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            return "iOS";
        }
    
        return "unknown";
    }

    useEffect(() => {
        if(!glbUrl) {
            return;
        }

        const iframeDoc = iframeRef?.current?.contentDocument || iframeRef?.current?.contentWindow.document;
        iframeDoc.open();

        const device = getMobileOperatingSystem();
        let arMode = 'scene-viewer quick-look';

        if(device == 'Android') {
            arMode = 'webxr';
        }
        
        iframeDoc.write(`
            <!DOCTYPE html>
            <html lang="en">
                <head>
                <meta charset="UTF-8">
                <meta name="viewport" content="width=device-width, initial-scale=1.0">
                <title>GLB Viewer</title>
                <script type="module" src="https://unpkg.com/@google/model-viewer/dist/model-viewer.min.js"></script>
                </head>
                <body>
                    <model-viewer
                        id='modelViewer'
                        class="ModelViewer"
                        src="`+glbUrl+`"
                        alt="`+name+`"
                        poster="`+logo+`"
                        alt="A 3D model"
                        shadow-intensity="0"
                        camera-controls="camera-controls"
                        interaction-prompt-style="basic"
                        interaction-prompt-threshold={1000} 
                        ar
                        ar-modes="`+arMode+`"
                        ar-scale="auto"
                        ar-placement="floor"
                        scale="0.01 0.01 0.01"
                        quick-look-browsers="safari chrome"
                        style="width: 100%; height: 90vh;"
                    >
                    </model-viewer>
                </body>
            </html>
        `);

        iframeDoc.close();
    }, [glbUrl]);

    return (
        <>
            <iframe
                ref={iframeRef}
                style={{
                    width: "100%",
                    height: "100%",
                    border: "none"
                }}
                >
            </iframe>
            <Button
                onClick={() => { navigate('/public/project/view/' + token) }}
                variant="contained"
                startIcon={<ArrowBack />}
                style={{
                    position: 'absolute',
                    top: '25px',
                    right: '16px'
                }}
            >
                <Trans>Back</Trans>
            </Button>
        </>
    );
}

export default ProjectPublicAR;
